import Button, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingButtonWrapper: {
      display: 'inline-flex',
      position: 'relative',
    },
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    }
  })
);

interface Props {
  loading: boolean;
  tooltip?: string;
}

function LoadingButton(props: Props & ButtonProps) {
  const classes = useStyles({});
  const { loading, tooltip, children, style, variant, ...other } = props;

  return (
    <div className={classes.loadingButtonWrapper} style={style}>
      <Tooltip title={tooltip || ''}>
        <Button disabled={loading} variant={variant || 'outlined'} {...other}>{children}</Button>
      </Tooltip>
      {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
    </div>
  );
};

export default LoadingButton;
